/**
 * Generates an image URL with optional transformations
 * @param {Object} options - The options object
 * @param {string} options.cdnUrl - The CDN base URL
 * @param {string} options.bucket - The bucket name
 * @param {string} options.key - The image key/path
 * @param {Object} options.transforms - Optional transformations
 * @param {number} options.transforms.width - Desired width
 * @param {number} options.transforms.height - Desired height
 * @param {string} options.transforms.fit - Fit mode: "cover" | "contain" | "fill" | "inside" | "outside"
 * @param {number} options.transforms.quality - Image quality (0-100)
 * @returns {string} The generated image URL
 */
export function getImageUrl({ cdnUrl, bucket, key, transforms }) {
    const request = {
        bucket,
        key
    };

    if (transforms) {
        request.edits = {};

        if (transforms.width || transforms.height || transforms.fit) {
            request.edits.resize = {
                ...(transforms.width && { width: transforms.width }),
                ...(transforms.height && { height: transforms.height }),
                ...(transforms.fit && { fit: transforms.fit })
            };
        }

        if (transforms.quality) {
            request.edits.jpeg = {
                quality: transforms.quality
            };
        }
    }

    const encoded = btoa(JSON.stringify(request));
    return `${cdnUrl}/${encoded}`;
}